import { isSSR } from "./is-ssr";

export function isTizen(): boolean {
  if (isSSR()) {
    return false;
  }
  return "tizen" in window;
}
